export default __webpack_public_path__ + "static/media/Macrobac-15-ml-ban.e07ff598.jpg";